import isInIframe from '@anm/helpers/is/isInIframe';
import { useCallback, useEffect, useState } from 'react';

var useDynamicPage = function useDynamicPage(props) {
  var _useState = useState(props === null || props === void 0 ? void 0 : props.pageFromProps),
      page = _useState[0],
      setPage = _useState[1];

  var onReceiveMessage = function onReceiveMessage(_ref) {
    var data = _ref.data;
    data.landing && updatePage(data.landing);
  };

  useEffect(function () {
    window.parent.postMessage({
      mounted: true
    }, '*');
  }, []);
  useEffect(function () {
    if (!isInIframe()) return;
    window.addEventListener('message', onReceiveMessage);
    return function () {
      return window.removeEventListener('message', onReceiveMessage);
    };
  }, []);
  var updatePage = useCallback(function (page) {
    var _props$onSetPage;

    setPage(page);
    props === null || props === void 0 ? void 0 : (_props$onSetPage = props.onSetPage) === null || _props$onSetPage === void 0 ? void 0 : _props$onSetPage.call(props, page);
  }, []);
  return [page, updatePage];
};

export default useDynamicPage;